import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  TimePicker,
  Button,
  Modal,
} from "antd";
import { useSelector } from "react-redux";
import { RiCloseFill, RiCalendarLine } from "react-icons/ri";
import { InfoNotification } from "../Notification/ToastNotification";
import { useTranslation } from "react-i18next";
import { FiUser, FiMail, FiPhone, FiCalendar, FiMapPin, FiGlobe, FiClock, FiEdit2 } from "react-icons/fi";

const ProfileInfo = () => {
  const [contactModalVisible, setContactModalVisible] = useState(false);
  const [preferenceModalVisible, setPreferenceModalVisible] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const { t } = useTranslation();

  const contactModalShow = () => {
    setContactModalVisible(true);
  };

  const contactModalCancel = () => {
    setContactModalVisible(false);
  };

  const preferenceModalShow = () => {
    setPreferenceModalVisible(true);
  };

  const preferenceModalCancel = () => {
    setPreferenceModalVisible(false);
  };

  const contactFields = [
    { icon: FiUser, label: t("profile.personalInfo.fullName"), value: user?.name },
    { icon: FiMail, label: t("profile.personalInfo.email"), value: user?.email },
    { icon: FiPhone, label: t("profile.personalInfo.phone"), value: user?.phone },
    { icon: FiCalendar, label: t("profile.personalInfo.dateOfBirth"), value: user?.dateOfBirth },
    { icon: FiMapPin, label: t("profile.personalInfo.address"), value: user?.address },
  ];

  const preferenceFields = [
    { icon: FiGlobe, label: t("profile.personalInfo.language"), value: t("profile.personalInfo.english") },
    { icon: FiCalendar, label: t("profile.personalInfo.dateFormat"), value: "YYYY/MM/DD" },
    { icon: FiClock, label: t("profile.personalInfo.timeZone"), value: "Dubai (GMT+4)" },
  ];

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "20px 24px" }}>
      {/* Page Header */}
      <div style={{ marginBottom: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "4px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #8B5CF6, #7C3AED)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiUser size={20} color="white" />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: "20px", fontWeight: 600, color: "#1e293b" }}>
              {t("profile.personalInfo.personalInformation")}
            </h1>
            <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
              Manage your personal details and preferences
            </p>
          </div>
        </div>
      </div>

      {/* Contact Information Card */}
      <div style={{
        background: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        marginBottom: "16px",
        overflow: "hidden",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #f1f5f9",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <FiUser size={16} color="#8B5CF6" />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}>
              {t("profile.personalInfo.contact")}
            </span>
          </div>
          <button
            onClick={() => InfoNotification("Coming soon")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px 14px",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              background: "#fff",
              color: "#64748b",
              fontSize: "12px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.15s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#8B5CF6";
              e.currentTarget.style.color = "#8B5CF6";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e2e8f0";
              e.currentTarget.style.color = "#64748b";
            }}
          >
            <FiEdit2 size={12} />
            {t("profile.personalInfo.edit")}
          </button>
        </div>

        <div style={{ padding: "8px 20px 16px" }}>
          {contactFields.map((field, idx) => {
            const Icon = field.icon;
            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 0",
                  borderBottom: idx < contactFields.length - 1 ? "1px solid #f8fafc" : "none",
                }}
              >
                <div style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "6px",
                  background: "#f8fafc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}>
                  <Icon size={14} color="#94a3b8" />
                </div>
                <div style={{ flex: 1 }}>
                  <span style={{ fontSize: "12px", color: "#94a3b8", display: "block", marginBottom: "2px" }}>
                    {field.label}
                  </span>
                  <span style={{ fontSize: "14px", fontWeight: 500, color: field.value ? "#1e293b" : "#94a3b8" }}>
                    {field.value || <i>{t("profile.personalInfo.notSet")}</i>}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Preferences Card */}
      <div style={{
        background: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        overflow: "hidden",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #f1f5f9",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <FiGlobe size={16} color="#7C3AED" />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}>
              {t("profile.personalInfo.preferences")}
            </span>
          </div>
          <button
            onClick={() => InfoNotification("Coming soon")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px 14px",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              background: "#fff",
              color: "#64748b",
              fontSize: "12px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.15s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#7C3AED";
              e.currentTarget.style.color = "#7C3AED";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e2e8f0";
              e.currentTarget.style.color = "#64748b";
            }}
          >
            <FiEdit2 size={12} />
            {t("profile.personalInfo.edit")}
          </button>
        </div>

        <div style={{ padding: "8px 20px 16px" }}>
          {preferenceFields.map((field, idx) => {
            const Icon = field.icon;
            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 0",
                  borderBottom: idx < preferenceFields.length - 1 ? "1px solid #f8fafc" : "none",
                }}
              >
                <div style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "6px",
                  background: "#f8fafc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}>
                  <Icon size={14} color="#94a3b8" />
                </div>
                <div style={{ flex: 1 }}>
                  <span style={{ fontSize: "12px", color: "#94a3b8", display: "block", marginBottom: "2px" }}>
                    {field.label}
                  </span>
                  <span style={{ fontSize: "14px", fontWeight: 500, color: "#1e293b" }}>
                    {field.value}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Modals remain the same */}
      <Modal
        title="Contact Edit"
        width={416}
        centered
        visible={contactModalVisible}
        onCancel={contactModalCancel}
        footer={null}
        closeIcon={
          <RiCloseFill className="remix-icon text-color-black-100" size={24} />
        }
      >
        <Form layout="vertical" name="basic" initialValues={{ remember: true }}>
          <Form.Item label="Full Name" name="fullname">
            <Input />
          </Form.Item>
          <Form.Item label="Display Name" name="displayname">
            <Input />
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input />
          </Form.Item>
          <Form.Item label="Phone" name="phone">
            <Input />
          </Form.Item>
          <Form.Item label="Date of Birth" name="dateofbirth">
            <DatePicker
              className="hp-w-100"
              suffixIcon={<RiCalendarLine className="remix-icon hp-text-color-black-60" />}
            />
          </Form.Item>
          <Form.Item label="Address" name="address">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Row>
            <Col md={12} span={24} className="hp-pr-sm-0 hp-pr-12">
              <Button block type="primary" htmlType="submit" onClick={contactModalCancel}>
                {t("profile.personalInfo.edit")}
              </Button>
            </Col>
            <Col md={12} span={24} className="hp-mt-sm-12 hp-pl-sm-0 hp-pl-12">
              <Button block onClick={contactModalCancel}>
                {t("profile.personalInfo.cancel")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title="Preference Edit"
        width={316}
        centered
        visible={preferenceModalVisible}
        onCancel={preferenceModalCancel}
        footer={null}
        closeIcon={
          <RiCloseFill className="remix-icon text-color-black-100" size={24} />
        }
      >
        <Form layout="vertical" name="basic" initialValues={{ remember: true }}>
          <Form.Item label="Language" name="language">
            <Input />
          </Form.Item>
          <Form.Item label="Date Format" name="dateformat">
            <DatePicker
              className="hp-w-100"
              suffixIcon={<RiCalendarLine className="remix-icon hp-text-color-black-60" />}
            />
          </Form.Item>
          <Form.Item label="Timezone" name="timezone">
            <TimePicker className="hp-w-100" />
          </Form.Item>
          <Row>
            <Col md={12} span={24} className="hp-pr-sm-0 hp-pr-12">
              <Button block type="primary" htmlType="submit" onClick={preferenceModalCancel}>
                {t("profile.personalInfo.edit")}
              </Button>
            </Col>
            <Col md={12} span={24} className="hp-mt-sm-12 hp-pl-sm-0 hp-pl-12">
              <Button block onClick={preferenceModalCancel}>
                {t("profile.personalInfo.cancel")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default ProfileInfo;
